import {ValidationResult, ValidationRules} from './types';

/**
 * Tool for validate forms and flat objects
 *
 * @example
 * import React, {useState} from 'react';
 *
 * function ValidationExample () {
 *     const [form, setForm] = useState({
 *         name: '',
 *         email: '',
 *         about: '', //optional
 *     })
 *
 *     const errors = useMemo(()=>validate(form, {
 *         name: [required()],
 *         email: [required(), email()]
 *     }), [form])
 *
 *     const handleChange = (e) =>
 *         setForm( prev => ({ ...prev, [e.target.name]: e.target.value })
 *
 *     return (
 *         <form>
 *             <label>
 *                 Name
 *                 <input name='name' type='text' onChange={handleChange}/>
 *                 {errors.name}
 *             </label>
 *             <label>
 *                 Email
 *                 <input name='email' type='text' onChange={handleChange}/>
 *                 {errors.email}
 *             </label>
 *             <label>
 *                 About
 *                 <textarea name='about' rows={3} onChange={handleChange}/>
 *                 {errors.about}
 *             </label>
 *         </form>
 *     )
 * }
 */
export const validate = <T extends object>(formData: T, rules: ValidationRules<T>): ValidationResult<T> => {
    const validationResult: ValidationResult<T> = {};

    for (const field in rules) {
        const fieldRules = rules[field];
        const fieldValue = formData[field];

        if (fieldRules) {
            for (const rule of fieldRules) {
                const error = rule(fieldValue);
                if (error) {
                    validationResult[field] = error;
                    break;
                }
            }
        }
    }

    return validationResult;
};
